export default {
  home: 'Home',
  separator: '',
};



// WEBPACK FOOTER //
// ./src/widgets/breadcrumb/defaultTemplates.js